import { useEffect, useState } from "react";
import { Code2, Search, ClipboardList } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [action, setAction] = useState("");
  const [actor, setActor] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/logs", { params: { action, actor, limit: 200 } });
      setLogs(data.logs || []);
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchLogs(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-4 pt-16 sm:p-8 lg:p-12 max-w-6xl mx-auto animate-fade-up">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-400/10 text-cyan-600 text-xs font-semibold mb-3">
        <Code2 className="w-3.5 h-3.5" /> DEV
      </div>
      <h1 className="font-display text-4xl font-medium c-strong mb-2">Log Aktivitas</h1>
      <p className="text-sm c-muted mb-6">Catatan upload, hapus, login, perubahan akun, dan cleanup file hilang.</p>

      <div className="c-card border rounded-xl p-4 card-elev mb-5 grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-3">
        <input value={action} onChange={(e) => setAction(e.target.value)} placeholder="Filter aksi..." className="border c-input rounded-lg px-3 py-2 text-sm" />
        <input value={actor} onChange={(e) => setActor(e.target.value)} placeholder="Filter staff/developer..." className="border c-input rounded-lg px-3 py-2 text-sm" />
        <button onClick={fetchLogs} className="bg-gold text-white rounded-lg px-4 py-2 text-sm flex items-center justify-center gap-2">
          <Search className="w-4 h-4" /> Cari
        </button>
      </div>

      <div className="c-card border rounded-xl card-elev overflow-hidden">
        <table className="w-full text-sm text-left">
          <thead className="c-soft c-muted text-xs uppercase tracking-wider">
            <tr><th className="px-5 py-3">Waktu</th><th className="px-5 py-3">Aksi</th><th className="px-5 py-3">Pelaku</th><th className="px-5 py-3">Detail</th></tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan={4} className="px-5 py-12 text-center c-muted">Memuat...</td></tr> : logs.length === 0 ? (
              <tr><td colSpan={4} className="px-5 py-12 text-center c-muted"><ClipboardList className="w-8 h-8 mx-auto mb-2 text-gold" />Belum ada log.</td></tr>
            ) : logs.map((log) => (
              <tr key={log._id} className="border-t c-border align-top">
                <td className="px-5 py-3 font-mono text-xs c-muted whitespace-nowrap">{new Date(log.created_at).toLocaleString("id-ID")}</td>
                <td className="px-5 py-3 font-medium c-strong">{log.action}</td>
                <td className="px-5 py-3 c-muted">{log.actor_name || "-"}<div className="text-xs opacity-70">{log.actor_email || "system"}</div></td>
                <td className="px-5 py-3">
                  <pre className="max-w-md rounded-lg border c-border bg-[#F7F3EA] p-3 text-xs whitespace-pre-wrap break-all text-[#1F2933] dark:bg-[#0B1014] dark:text-[#DDE7F0] dark:border-white/10">
                    {JSON.stringify(log.metadata || {}, null, 2)}
                  </pre>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
